/**
 * Префикс, под которым развёрнута платформа.
 *
 * Пусто при обычной установке на свой домен и равно, например, `/region35`,
 * когда платформа живёт в подкаталоге чужого сайта.
 *
 * Значение приходит из NEXT_PUBLIC_BASE_PATH и ПРОШИВАЕТСЯ В СБОРКУ: Next
 * подставляет его в клиентские бандлы на этапе build, поэтому поменять
 * префикс у готовой сборки нельзя — нужна пересборка. Так устроен basePath
 * в Next, и здесь мы просто читаем ту же переменную, чтобы одно и то же
 * значение было и в конфиге сборки, и в коде.
 *
 * Что basePath делает САМ: next/link, router.push, сами маршруты страниц и
 * адреса статики из /_next. Что он НЕ делает: прямые обращения из браузера —
 * fetch('/api/…'), window.location.href = '/login', src="/brand/…" и путь
 * подключения socket.io. Для них и нужен этот модуль.
 */
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? '';

/**
 * Дописать префикс к абсолютному пути внутри приложения.
 *
 * Внешние адреса (http://…, //…), относительные пути и уже префиксованные
 * строки возвращаются как есть — функция безопасна при повторном вызове.
 */
export function withBase(path: string): string {
  if (!BASE_PATH) return path;
  if (typeof path !== 'string' || !path.startsWith('/')) return path;
  if (path.startsWith('//')) return path;
  if (path === BASE_PATH || path.startsWith(`${BASE_PATH}/`)) return path;
  return `${BASE_PATH}${path}`;
}

/** Путь подключения socket.io с учётом префикса. */
export const SOCKET_PATH = `${BASE_PATH}/socket.io`;
